var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.PerfilSocioAvanzado)?_c('MemberProfile',{attrs:{"isCap":true}}):_c('ProfileMemberCap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }